import React from 'react';
import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const FirstRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const Title = styled.p`
	margin: 0px;
	font-size: 2rem;
	letter-spacing: 0px;
	line-height: 1;
	font-weight: 900;
`;

const Description = styled.p`
	margin: 0px;
	font-size: 0.875rem;
	color: #4b5865;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
`;

interface HeaderProps {
	title: string;
	description?: string;
	headerComponents?: ReactElement[];
}

export default function Header({ title, description, headerComponents }: HeaderProps) {
	const user = useSelector((state: any) => state.auth.user);

	return (
		<Wrapper>
			<FirstRow>
				<div>
					<Description>{user.shop_name}</Description>
					<Title>{title}</Title>
				</div>
				<ButtonContainer>
					{headerComponents &&
						headerComponents.map((component, index) => React.cloneElement(component, { key: index }))}
				</ButtonContainer>
			</FirstRow>
			{/* <Description>{description}</Description> */}
		</Wrapper>
	);
}
